import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { fetchWebloginVehicle } from '../actions';
import { selectMe, selectWork } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import { selectWebloginVehicle } from '../selectors';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { HBox, VBox } from '../../../components/Box';
import { Check } from 'react-feather';
import { Times } from '../../../components/Icon';
import _ from 'lodash';
import { VehicleDataConsumptionCard } from '../../Vehicles/components/ConsumptionEnviromentData';
import { VehicleRDWandHistoryDataCard } from '../../Vehicles/components/RDWandHistoryCard';
import { VehicleDocumentsCard } from '../../Vehicles/components/CardDocuments';
import { WebloginVehicleInfoCard } from '../components/WebloginVehicleInfoCard';
import { WebloginVehicleDataCard } from '../components/WebloginVehicleDataCard';
import { WebloginVehicleOutgoingInvoiceCard } from '../components/WebloginOutgoingInvoiceCard';
import { WebloginVehicleInvoicesCard } from '../components/WebloginVehicleInvoicesCard';
import { WebloginVehicleFinancePurchaseCard } from '../components/WebloginVehiclePurchaseCard';
import cn from 'classnames';
import styles from './vehicle.module.css';
import { VehicleTasksCard } from '../../Vehicles/components/CardVehicleTasks';
import { WEBLOGIN_FETCH_VEHICLE } from '../constants';

//import { VehicleTasksCard } from '../../Vehicles/components/CardVehicleTasks';
//import { VehicleHooicardtakeout } from '../../Vehicles/components/cardHooicardtakeout';
import { VehicleHooicardtakeout } from '../../Vehicles/components/cardHooicardtakeout';
import { EditVehicleOptions } from '../../Vehicles/pages/create/OptionsStep/EditVehicleOptions';
import { Card } from '../../../components/Card';
import { VehicleOptionsCard } from '../../Vehicles/components/VehicleOptionsCard';
import { VehicleLocationCard } from '../../Vehicles/components/VehicleLocationCard';
import { AppClientId } from '../../Shared/constants';
import env from '../../../env';
import { VehicleHooiInstallationPhotoCard } from '../../Vehicles/components/CardHooiInstallationPhotos';

const Container = styled.div`
  min-width: 1024px;
  .vehicle-row {
    border-bottom: 1px solid #ddd;
    padding: 6px;

    .img {
      margin: 0;
    }

    > div {
      min-width: 100px;
    }
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .prop {
    border-bottom: 1px solid #ddd;
    padding: 12px;
  }

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;
const STATE = {
  selected: null,
};
/* eslint-disable react/prefer-stateless-function */
class WebloginVehiclePageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.get();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get weblogin() {
    return this.props.me.weblogin;
  }

  get isCreditor() {
    return this.vehicle?.creditor_company;
  }

  get isDebitor() {
    return this.vehicle?.isDebitor && this.vehicle.invoice_outgoing_company_id;
  }

  get properties() {
    let props = [];
    for (let name in this.vehicle) {
      if (name == 'props') continue;
      if (name == 'documents') continue;
      props.push({ name, value: this.vehicle[name] });
    }
    return props;
  }

  render() {
    if (this.props.loading || !this.vehicle) return <Loader small />;
    return (
      <Container>
        <WebloginVehicleInfoCard weblogin={this.weblogin} vehicle={this.vehicle} />
        <div className={cn('row', styles.row)}>
          <div className="col">
            <WebloginVehicleDataCard vehicle={this.vehicle} />
            <VehicleDataConsumptionCard vehicle={this.vehicle} />
          </div>
          <div className="col">
            {this.isDebitor && <WebloginVehicleOutgoingInvoiceCard vehicle={this.vehicle} />}
            <VehicleHooiInstallationPhotoCard vehicle={this.props.vehicle} />

            <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '200%' }}>
              <EditVehicleOptions photoBlock webLogin vehicle={this.vehicle} />
            </Card>
            <VehicleOptionsCard vehicle={this.vehicle} weblogin={this.weblogin} />
          </div>
          <div className="col">
            {/* <VehicleRDWandHistoryDataCard vehicle={this.vehicle} /> */}
            {this.isCreditor && <WebloginVehicleFinancePurchaseCard vehicle={this.vehicle} weblogin={this.weblogin} />}
            <VehicleDocumentsCard vehicle={this.vehicle} weblogin={this.weblogin} />
            {/* <VehicleHooicardtakeout vehicle={this.vehicle} /> */}
            <VehicleLocationCard vehicle={this.props.vehicle} weblogin={this.weblogin} />
          </div>

          {/* <WebloginVehicleInvoicesCard vehicle={this.props.vehicle} weblogin={this.weblogin} /> */}
        </div>
      </Container>
    );
  }

  renderVehicle(vehicle) {
    return (
      <HBox key={vehicle.id} left vCenter className="vehicle-row" gap={24}>
        <div>
          <VehicleAvatar vehicle={vehicle} />
          <div style={{ color: '#aaa', fontSize: '12px' }}>{vehicle.id}</div>
        </div>
        <div>{vehicle.regplate}</div>
        <div>
          {vehicle.brand_name}
          <br />
          {vehicle.model_name}
          <br />
          {vehicle.model_extra}
          <br />
        </div>
      </HBox>
    );
  }

  renderProperty(prop) {
    let value = prop.value;
    return (
      <HBox className="prop" left>
        <div style={{ width: '300px' }}>{prop.name}</div>
        <div>
          {value === true ? <Check /> : value === false ? <Times /> : _.isObject(value) ? JSON.stringify(value) : value}
        </div>
      </HBox>
    );
  }
}

WebloginVehiclePageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(`${WEBLOGIN_FETCH_VEHICLE}-${ownProps.vehicleId}`),
    vehicle: selectWebloginVehicle(ownProps.vehicleId),
    me: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get() {
      dispatch(fetchWebloginVehicle(ownProps.vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehiclePage = compose(withConnect, withRouter)(WebloginVehiclePageComp);
